import App from 'app/app.js';

function LtAppVersionUpdate() {
  return {
    restrict: 'E',
    scope: {
      onCancel: '&',
      onEmit: '&'
    },
    template:
      '    <div class="modal-body" ng-init="appVersionUpdate.init()" lt-drawer="appVersionUpdate.visible" lt-drawer-cancellation="appVersionUpdate.close(); onCancel()">' +
      '        <div class="app-version-update">' +
      '           <div class="main">' +
      '               <lt-icon name="fa-sharp-solid-times" class="fa-close" ng-click="appVersionUpdate.close()"></lt-icon>' +
      '               <div class="update-available">' +
      '                   <img class="update-available-icon" src="assets/images/icons/update-available.svg">' +
      '               </div>' +
      '               <div class="title" lt-translate="APP_VERSION_UPDATE_HEADER"></div>' +
      '           </div>' +
      '           <div class="detail">' +
      '               <div class="desc" lt-translate="APP_VERSION_UPDATE_SUB_TEXT"></div>' +
      '               <button lt-translate="APP_VERSION_UPDATE_BUTTON" class="btn" ng-click="onEmit(); appVersionUpdate.close()"></button>' +
      '           </div>' +
      '        </div>' +
      '    </div>',
    controller: function () {
      this.visible = false;

      this.init = function () {
        this.visible = true;
      };
      this.close = function () {
        this.visible = false;
      };
    },
    controllerAs: 'appVersionUpdate'
  };
}

App.directive('ltAppVersionUpdate', [LtAppVersionUpdate]);
